export default __webpack_public_path__ + "static/ventajas-01-07-33ee13524523d7bdf92e0aecdc3b800c.svg";